module.exports = __webpack_public_path__ + "img/9788988182987.22f92df7.jpg";